import { render, staticRenderFns } from "./WidgetCoupon.vue?vue&type=template&id=513f188b&"
import script from "./WidgetCoupon.vue?vue&type=script&lang=ts&"
export * from "./WidgetCoupon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports